import { findParentNodeOfType, findSelectedNodeOfType } from '@atlaskit/editor-prosemirror/utils';
export var findSyncBlock = function findSyncBlock(state, selection) {
  var syncBlock = state.schema.nodes.syncBlock;
  return findSelectedNodeOfType(syncBlock)(selection || state.selection) || findParentNodeOfType(syncBlock)(selection || state.selection);
};